export const engagementRecommenderAnalytics = "/engagement/recommender_analytics";
